export default {
  会员中心: '会员中心',
  企业云展系统: '企业云展系统',
  企业云展: '企业云展',
  我的云企业: '我的云企业',
  企业动态: '企业动态',
  我的企业动态: '我的企业动态',
  企业资料库: '企业资料库',
  客户数据: '客户数据',
  子账号管理: '子账号管理',
  展览管理: '展览管理',
  会议管理: '会议管理',
  头条管理: '头条管理',
  招标管理: '招标管理',
  我的展览: '我的展览',
  参展报名: '参展报名',
  参观报名: '参观报名',
  展厅搭建报名: '展厅搭建报名',
  我的会议: '我的会议',
  参加报名: '参加报名',
  会议赞助: '会议赞助',
  我的直播: '我的直播',
  产品管理: '产品管理',
  产品服务: '产品服务',
  采购管理: '采购管理',
  客户采购单: '客户采购单',
  我的采购单: '我的采购单',
  我的采购: '我的采购',
  订单管理: '订单管理',
  发票管理: '发票管理',
  我的名片: '我的名片',
  我的海报: '我的海报',
  我的收藏: '我的收藏',
  我的钱包: '我的钱包',
  基本资料: '基本资料',
  消息中心: '消息中心',
  大数据营销: '大数据营销',
  大数据获客: '大数据获客',
  短信邀约: '短信邀约',
  邮件邀约: '邮件邀约',
  精准邀约: '精准邀约',
  // 精准邀约: '精准邀约',
  通讯录: '通讯录',
  我的优惠券: '我的优惠券',
  云优惠: '云优惠',
}
